import { render, staticRenderFns } from "./passwordLogin.vue?vue&type=template&id=b3459184&scoped=true"
import script from "./passwordLogin.vue?vue&type=script&lang=js"
export * from "./passwordLogin.vue?vue&type=script&lang=js"
import style0 from "./passwordLogin.vue?vue&type=style&index=0&id=b3459184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3459184",
  null
  
)

export default component.exports